import React from 'react';
import { Card, Col, Row, Button } from 'react-bootstrap';
import QrImg from 'assets/img/hodlie/qr-code.png';

const ClosingPage = () => {
  const link = 'https://hodli.com/download';

  return (
    <>
      <Row className="mt-3">
        <Col>
          <Card>
            <Card.Header>
              <h4 className="mb-0">Hodlie è diventato Hodli</h4>
            </Card.Header>
            <Card.Body>
              <p className="mb-2">
                Da questo momento puoi accedere alla nuova app Hodli con le
                stesse credenziali e iniziare a gestire i tuoi investimenti in
                modo strutturato, coerente e consapevole.
              </p>
              <p className="mb-3">
                <b>Di seguito alcuni dettagli importanti:</b>
                <ul className="mb-0">
                  <li>
                    Il portafoglio di Binance che avevi collegato a Hodlie è
                    stato automaticamente scollegato e la tua chiave API è stata
                    eliminata: tutti i tuoi fondi sono disponibili su Binance.
                    Per prelevarli, segui questa guida:{' '}
                    <a
                      href="https://support.hodli.com/come-prelevare-i-tuoi-fondi-da-binance"
                      target="_blank"
                      rel="noreferrer"
                    >
                      https://support.hodli.com/come-prelevare-i-tuoi-fondi-da-binance
                    </a>
                  </li>
                  <li>
                    Il rinnovo automatico del tuo abbonamento è stato annullato:
                    riceverai il credito residuo su Hodli e potrai utilizzarlo
                    per pagare i costi del nuovo servizio.
                  </li>
                  <li>
                    Non potrai più accedere alla piattaforma attuale: l'accesso
                    è stato disattivato e potrai usare le stesse credenziali
                    sulla nuova Hodli.
                  </li>
                </ul>
              </p>
              <h6 className="mt-2">Scarica l'app e accedi:</h6>
              <Row className="g-3 mt-1 justify-content-center">
                <Col sm={12} className="d-flex">
                  <Button
                    as="a"
                    href={link}
                    target="_blank"
                    rel="noreferrer"
                    variant="falcon-default"
                    className="w-100 pb-md-3"
                  >
                    <span className="text-center d-md-none py-10">
                      Clicca per scaricare l'app
                    </span>
                    <div className="mt-2 d-none d-md-flex justify-content-center">
                      <img
                        src={QrImg}
                        alt="QR App Store"
                        style={{
                          width: '300px',
                          height: '300px',
                          borderRadius: '10px'
                        }}
                      />
                    </div>
                  </Button>
                </Col>
              </Row>
            </Card.Body>
            <Card.Footer></Card.Footer>
          </Card>
        </Col>
      </Row>
      <Row className="my-3">
        <Col>
          <Card>
            <Card.Header>
              <h5 className="mb-0">Domande frequenti</h5>
            </Card.Header>
            <Card.Body>
              <h6 className="mb-1">Vuoi più informazioni?</h6>
              <p className="mb-2">
                Trovi tutte le informazioni su Hodli su{' '}
                <a target="_blank" rel="noreferrer" href="https://hodli.com">
                  hodli.com
                </a>
                .
              </p>
              <h6 className="mb-1">Vuoi spostare i tuoi fondi da Binance?</h6>
              <p className="mb-2">
                Segui la{' '}
                <a
                  href="https://support.hodli.com/come-prelevare-i-tuoi-fondi-da-binance"
                  target="_blank"
                  rel="noreferrer"
                >
                  guida al trasferimento dei fondi passo-passo
                </a>{' '}
                per completare l’operazione in sicurezza.
              </p>
              <h6 className="mb-1">Non sai come proseguire?</h6>
              <p className="mb-0">
                Contattaci tramite mail per ricevere supporto personalizzato
                all'indirizzo{' '}
                <a href="mailto:support@hodli.com">support@hodli.com</a>.
              </p>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default ClosingPage;
